var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.5C0.95 5.5 0.5 5.95 0.5 6.5V10C0.5 10.55 0.95 11 1.5 11C2.05 11 2.5 10.55 2.5 10V6.5C2.5 5.95 2.05 5.5 1.5 5.5ZM9.995 8.5H6.58C6.525 8.5 6.47 8.49 6.415 8.47L5.68 8.215C5.55 8.17 5.485 8.03 5.53 7.9C5.575 7.77 5.72 7.7 5.85 7.75L6.41 7.965C6.465 7.985 6.53 8 6.59 8H7.905C8.23 8 8.495 7.735 8.495 7.41C8.495 7.165 8.34 6.945 8.11 6.855L4.65 5.565C4.54 5.52 4.42 5.5 4.3 5.5H3.5V10.01L6.685 10.915C6.89 10.975 7.11 10.965 7.31 10.89L11 9.5C11 8.945 10.55 8.5 9.995 8.5Z",
    fill: "#3367CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.8375L8.1375 5.5075C6.85 4.34 6 3.57 6 2.625C6 1.855 6.605 1.25 7.375 1.25C7.81 1.25 8.2275 1.4525 8.5 1.7725C8.7725 1.4525 9.19 1.25 9.625 1.25C10.395 1.25 11 1.855 11 2.625C11 3.57 10.15 4.34 8.8625 5.51L8.5 5.8375Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportSmall);
export default __webpack_public_path__ + "static/media/supportSmall.33573e53.svg";
export { ForwardRef as ReactComponent };